import { doc, getDoc } from 'firebase/firestore';

/** Firestore + Storage paths for workspace brand kit (video watermark — applied when export ships). */

/** Canonical settings doc id — not a collaborator mirror (those use owner UID as doc id). */
export const SETTINGS_BRANDING_DOC_ID = 'branding';

/** @deprecated Legacy collection/doc — read fallback until migration */
export const WORKSPACE_BRANDING_LEGACY_KIT_SEGMENTS = (uid) => ['users', uid, 'branding', 'kit'];

/** @param {import('firebase/firestore').Firestore} db @param {string} uid */
export function workspaceBrandingRef(db, uid) {
  return doc(db, 'users', uid, 'settings', SETTINGS_BRANDING_DOC_ID);
}

/** @param {import('firebase/firestore').Firestore} db @param {string} uid */
export function workspaceBrandingLegacyRef(db, uid) {
  return doc(db, ...WORKSPACE_BRANDING_LEGACY_KIT_SEGMENTS(uid));
}

/** @param {string} uid */
export function workspaceBrandLogoStoragePath(uid) {
  return `users/${uid}/branding/logo.png`;
}

/** Read brand kit Firestore doc (canonical settings/branding, then legacy branding/kit). */
export async function getWorkspaceBrandingSnap(db, uid) {
  const canonical = await getDoc(workspaceBrandingRef(db, uid));
  if (canonical.exists()) return canonical;
  return getDoc(workspaceBrandingLegacyRef(db, uid));
}
